import Symbol from '.Symbol';
import Object from '.Object';

export const _literal                = Symbol('_literal')       ;

export const LiteralObject =                                                             (literal         , value                                   ) => {
	const object = Object(value)                           ;
	object[_literal] = literal;
	return object;
};
